export enum SocialMediaType {
  YouTube = 'YouTube',
  Instagram = 'Instagram',
  Soundcloud = 'Soundcloud',
  Behance = 'Behance',
  Codepen = 'Codepen',
  Twitter = 'Twitter',
  Facebook = 'Facebook',
  LinkedIn = 'LinkedIn',
  TikTok = 'TikTok',
  Twitch = 'Twitch',
  Discord = 'Discord',
  GitHub = 'GitHub',
  Reddit = 'Reddit',
  WeChat = 'WeChat',
}

export type SocialMedia = {
  type: SocialMediaType;
  url: string;
};

export type SocialMediaTablePropsMicrocopy = {
  socialMedia: string;
};

export type SocialMediaTablePropsData = {
  socialMedias: SocialMedia[];
};

export type SocialMediaTablePropsDataWithMicrocopy =
  SocialMediaTablePropsData & {
    microcopy: SocialMediaTablePropsMicrocopy;
  };

export type SocialMediaTableProps = SocialMediaTablePropsDataWithMicrocopy & {
  className?: string;
};
